import type { Message } from "@/types/message";

import { OWNER } from "@/types/message";

export type MessageAuthorship = Pick<Message, "owner" | "isAiAssisted"> & {
  user?: Message["user"];
};

/**
 * Whether the words in this message are the AI's.
 *
 * `owner` is the delivery path, not the author: every reply the agent delivers
 * goes out `owner: ai` carrying the run id, including a draft the reviewer
 * rewrote before sending. What separates them is `isAiAssisted` — the backend
 * sets it false exactly when a human changed the draft, which is it saying the
 * text is theirs. So trust the flag; an AI-owned send with no human behind it
 * (autopilot) is the AI's by definition.
 */
export const aiWroteMessage = (message: MessageAuthorship): boolean =>
  Boolean(message.isAiAssisted) ||
  (message.owner === OWNER.AI && !message.user);
